const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18F(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 373.057 272.48 C 364.727 251.98 364.427 232.36 366.547 210.34 C 376.677 105.05 355.637 33.16 319.847 31.19 C 306.747 30.48 299.937 73.19 290.497 115.95 L 288.687 115.95 C 285.157 98.95 276.687 65.12 270.527 50.09 C 265.407 37.53 252.937 36.38 244.477 53.81 C 237.077 69.07 215.077 120.92 211.607 153.11 L 211.527 153.11 C 200.677 101.39 204.657 26.3 180.307 26.3 C 144.457 26.3 115.057 100.06 120.097 210.3 C 121.097 232.4 121.907 251.94 113.577 272.44 C 91.187 327.54 79.647 409.44 110.887 443.44 C 149.887 485.92 217.367 451.92 243.317 451.92 C 269.267 451.92 336.767 485.92 375.747 443.44 C 406.987 409.46 395.457 327.58 373.057 272.48 Z",
    style: {
      fill: "rgb(200, 218, 46)",
      stroke: "rgb(35, 24, 21)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 211.707 153.05 C 215.097 120.88 237.187 68.8 244.607 53.5 C 253.067 36.07 265.537 37.22 270.607 49.78 C 277.297 66.21 286.837 105.03 289.607 119.93",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 243.457 451.71 C 269.407 451.71 336.897 485.71 375.887 443.23 C 407.127 409.18 395.587 327.3 373.197 272.23 C 364.867 251.7 364.527 232.05 366.677 210.05 C 376.817 104.82 355.777 32.88 319.977 30.92 C 293.097 29.44 292.707 210.92 241.677 200.15 C 190.647 189.38 216.347 26.05 180.437 26.05 C 144.527 26.05 115.187 99.78 120.227 210.05 C 121.227 232.15 122.037 251.69 113.707 272.19 C 91.317 327.29 79.787 409.19 111.017 443.19 C 150.007 485.71 217.527 451.71 243.457 451.71 Z",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 241.527 378.3 C 237.927 397.92 232.627 404.58 222.637 406.25 C 192.317 411.32 168.277 422.36 145.237 405.56",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 228.737 428.84 C 232.847 425.68 236.737 418.64 239.597 413.84 C 243.537 407.2 248.597 404.84 256.177 405.49 C 283.527 408.05 295.817 425.78 322.467 419.25",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 150.087 262.77 C 203.977 243.55 313.497 243.37 344.507 270.77",
    style: {
      fill: "none",
      stroke: "rgb(99, 103, 106)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "6.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18F);
export default __webpack_public_path__ + "static/media/18f.93d5a133.svg";
export { ForwardRef as ReactComponent };